import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { defaultEventValidations } from "./schedule-validations";
import { TimeStrings } from "./event.types";

export const defaultSubEventValidations = (translate: UseIventisTranslate, timeStrings?: TimeStrings) => ({
    ...defaultEventValidations(translate, timeStrings),
});
